import { Breadcrumb } from "antd"
import { useHistory } from "react-router-dom"
export default function BreadCrumb() {
  const history = useHistory()
  return <Breadcrumb style={{ margin: "16px 20px" }} items={[{ title: "Home", title: history.location.pathname.replace("/", "") }]} />
}
